module.exports = __webpack_public_path__ + "static/rubine-8290fcb29ba920331c32c1539a4194af.png";